export default __webpack_public_path__ + "static/media/Delenia.64501fa1.png";